module.exports = __webpack_public_path__ + "img/image53.f759d878.webp";